// extracted by mini-css-extract-plugin
export default {"next_order":"Vy","recurringdis":"Wy","reactivate_button":"Xy","order__summary_title":"Yy","order__summary_items":"Zy","order__summary_item":"az","order__summary_item_title":"bz","order__summary_item_quantity":"cz","order__item_separator":"ez","discount":"fz","promowrapper":"gz"};
    if(module.hot) {
      // 1730991503236
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  